import FormationLayout from "./FormationLayout";

export default function FormationNoCode() {
  return (
    <FormationLayout
      seoTitle="Formation Automatisation No-code — Form Action Pro"
      seoDesc="Formation automatisation no-code : cartographier un processus, construire des scénarios d'automatisation entre vos outils, sans coder. Durée 2 à 4 jours, sur devis."
      path="/formations/automatisation-no-code"
      kicker="Formation"
      title="Automatisation No-code"
      subtitle="Concevoir et construire des automatisations sans écrire une ligne de code, pour gagner du temps au quotidien — seul ou en équipe."
      dureeBadge="2 à 4 jours"
      publicCible="Indépendants, TPE/PME, équipes administratives"
      objectifs={[
        "Cartographier un processus métier et repérer ce qui est automatisable.",
        "Construire des scénarios d’automatisation entre vos outils existants.",
        "Tester, fiabiliser et documenter une automatisation avant sa mise en production.",
        "Évaluer les limites, les coûts et la pérennité d’une solution no-code.",
      ]}
      programme={[
        {
          titre: "Panorama du no-code",
          texte:
            "Logique des outils no-code, grandes familles de solutions, ce que l’on peut construire — et ce qu’il vaut mieux ne pas automatiser.",
        },
        {
          titre: "Concevoir un processus",
          texte:
            "Cartographier une tâche répétitive : déclencheurs, actions, conditions, exceptions. La qualité de l’automatisation naît ici, avant tout outil.",
        },
        {
          titre: "Construire et connecter",
          texte:
            "Formulaires, tableurs, messageries, scénarios entre applications. Construction guidée d’automatisations pas à pas.",
        },
        {
          titre: "Projet fil rouge",
          texte:
            "Automatisation d’un cas réel de votre structure, testée, documentée et prête à l’emploi à la fin de la formation.",
        },
      ]}
      duree="2 à 4 jours"
      prerequis="aisance de base avec les outils numériques (navigation web, tableur, messagerie)."
    />
  );
}
